import { useQuery } from "@tanstack/react-query";
import { httpClient } from "@/shared/api/http-client";
import { getActiveTenantId } from "@/shared/tenant/active-tenant";
import type { CampaignDetail } from "./types";

/** GET /api/campaigns/{id} — the campaign with its templates and snapshot leads. */
export function useCampaignDetail(campaignId: string) {
  return useQuery({
    queryKey: ["campaign", getActiveTenantId(), campaignId] as const,
    queryFn: () => httpClient<CampaignDetail>(`/api/campaigns/${campaignId}`),
    enabled: !!campaignId,
  });
}
